import React from 'react';

export default class Notice extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={`notice ${this.props.status ? 'notice--show' : ''}`}>
                <button 
                    className='notice__close'
                    onClick = {() => this.props.updateNoticeStatus(false)}
                >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L18 18M18 18L35 35M18 18L35 1M18 18L1 35" stroke="black" strokeWidth="2"/>
                    </svg>
                </button>
                <h2 className='notice__title'>Подсказка</h2>
                <p className='notice__message'>Должны быть заполнены все обязательные поля</p>
            </div>
        )
    }
}